import { createModel } from '@rematch/core';
import type { CurveSettingsPayload, DisplaySettingsState, RootModel } from '@/components/WellLoggingOperations/types';
import { DepthType, DepthResearchType } from '@/components/WellLoggingOperations/types';

export const defaultColors = {
    // selection: '#5f8ff3', // todo add later
    border: '#e0e0e0',
    grp: '#21f920',
    isolation: '#6e80a1',
    primary_perforation: '#f65055',
    perforation: '#ff5252',
    pgi_zkc: '#ffffff',
    pgi_nek: '#ffffff',
    divider: '#cccccc',
    layer_connections: '#b9b9b9',
    title_background: '#eeeeee',
};

export const defaultDisplaySettings: DisplaySettingsState = {
    // Старые настройки, был запрос переделать по Пермь
    // ruler: {
    //     interval: 5,
    //     scale: 2,
    //     isDisplayBothDepths: false,
    // },
    ruler: {
        interval: 4,
        scale: 4,
        isDisplayBothDepths: true,
    },
    rappers: {
        isAllowedDrawRappers: true,
        isRapperConnectionMode: true,
        wellsGapWidth: 20,
        isNotDisplayRapperName: false,
        isNotPrintRapperName: false,
        isRecalculateDepths: false,
    },
    allGeoObjects: {
        displayStrataConnection: false,
    },

    geoObjects: {
        displayStrataConnection: false,
    },
    geoObjectsRigis: {
        displayStrataConnection: false,
    },
    geoObjectsFgi: {
        displayStrataConnection: false,
    },
    perforation: {
        isMultiColumns: false,
        isVisibleDate: true,
    },
    flowmetry: {
        isVisiblePGIOnly: false,
    },
    depthType: DepthType.Rel,
    depthResearchType: DepthResearchType.Inclinometry,
    isSyncScroll: false,
    colors: { ...defaultColors },
    globalCurvesSettings: {
        POR: {
            color: '',
            lineType: 0,
            lineWidth: 1,
            lineDisplay: 'dashed',
            isChangeMinMaxValues: false,
            isDecimalLog: false,
            minMaxValues: { xStart: 0, xStop: 100 },
            minPriority: false
        },
    },
    emptyColumnsDataSettings: false,
    isFirstDateCurve: true,
    isLastDateCurve: false,
    forceUpdateTablet: false,
};

export const displaySettingsModel = createModel<RootModel>()({
    name: 'displaySettings',
    state: {
        ...defaultDisplaySettings,
    },
    reducers: {
        setDisplaySettings(state, payload: Partial<DisplaySettingsState>) {
            return { ...state, ...payload };
        },
        setDepthType(state, payload: DepthType) {
            return { ...state, depthType: payload };
        },
        toggleSyncScroll(state) {
            return { ...state, isSyncScroll: !state.isSyncScroll };
        },
        setSyncScroll(state, payload: boolean) {
            return { ...state, isSyncScroll: payload };
        },
        setDepthResearchType(state, payload: DepthResearchType) {
            return { ...state, depthResearchType: payload };
        },
        setForceUpdateState(state, payload: boolean) {
            return { ...state, forceUpdateTablet: payload };
        },
        setIsVisiblePGIOnly(state, payload: boolean) {
            return { ...state, flowmetry: { ...state.flowmetry, isVisiblePGIOnly: payload } };
        },
    },

    effects: (dispatch: any) => ({
        updateDisplaySettings(payload: Partial<DisplaySettingsState>, rootState: any) {
            const currentState = rootState.displaySettings;

            const updatedSettings = {
                ...currentState,
                ...payload,
            };

            dispatch.displaySettings.setDisplaySettings(updatedSettings);
            dispatch.tablets.setTabletsScale(updatedSettings.ruler.scale);
        },
        updateGlobalCurveSettings(payload: CurveSettingsPayload, rootState: any) {
            const { key, color, lineType, lineWidth, lineDisplay, isChangeMinMaxValues, isDecimalLog, minMaxValues } =
                payload;
            const currentState = rootState.displaySettings;
            const updatedCurvesSettings = {
                ...currentState,
                globalCurvesSettings: {
                    ...currentState.globalCurvesSettings,
                    [key]: {
                        color,
                        lineType,
                        lineWidth,
                        lineDisplay,
                        isChangeMinMaxValues,
                        isDecimalLog,
                        minMaxValues,
                    },
                },
            };
            this.setDisplaySettings(updatedCurvesSettings);
        },
    }),
});
